export default __webpack_public_path__ + "static/media/SecondBoxIconV2.523b108d.svg";